export { CollectionList as default };

/**
* Items List Collection
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class CollectionList {
  /**
   * Confirmed identities list
   *
   * @public
   *
   * @type {Object.<ItemListEntity}
   *
   * @since 7.0.0
   */
  index = {};

  /**
   * Confirmed identities list
   *
   * @public
   *
   * @type {Array.<ItemListEntity}
   *
   * @since 7.0.0
   */
  items = [];

  /**
   * Number of items in the list
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  count = 0;

  /**
   * Defines the last item in the list
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  last;

  /**
   * Returns an Item by id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Number} id id
   *
   * @return {ItemListEntity|null}
   */
  get(id) {
    return this.index[id] || null;
  }

  /**
   * Adds an item to the collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Array|Object}  item item to add
   * @param {String|Number} id   item id
   *
   * @return {Boolean}
   */
  add(item, id) {
    if (this.index[id]) {
      return false;
    }

    this.index[id] = item;
    this.items.push(item);
    this.last = item;
    this.count++;
    return true;
  }

  /**
   * Adds multiple items to the collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Array} items items to add
   *
   * @return {void}
   */
  addItems(items) {
    for (let item in items) {
      this.add(items[item], item);
    }
  }

  /**
   * Deletes multiple items to the collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Array} items items to add
   *
   * @return {void}
   */
  deleteItems(items) {
    for (let item in items) {
      this.delete(items[item]);
    }
  }

  /**
   * Adds multiple items to the collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Array} items items to add
   *
   * @return {void}
   */
  addItemsAsKeys(items) {
    items.forEach((item) => {
      this.add(item, item);
    })
  }

  /**
   * Delets an item from the collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Boolean}
   *
   * @return {void}
   */
  delete(id) {
    if (!this.index[id]) {
      return false;
    }

    let item  = this.index[id];
    let index = this.items.indexOf(item);
    this.items.splice(index, 1);
    delete this.index[id];
    this.count--;
    return true;
  }

   /**
   * Returns collection index keys as an array
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Array}
   */
  getIndexKeys() {
    return Object.keys(this.index);
  }

  /**
   * Resets the collection list to it's initial state
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  reset() {
    this.index               = {};
    this.items               = [];
    this.count               = 0;
  }
}